import { connect } from 'react-redux';

import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { MapStateToProps } from '../../app/utils/ConnectUtils';
import { Omnibox, OmniboxOwnProps, OmniboxStateProps } from './Omnibox';

const mapStateToProps: MapStateToProps<OmniboxStateProps> = (state: AppState) => ({
  siteRole: SessionSiteSelectors.siteRole(state),
});

export const ConnectedOmnibox: React.ComponentClass<OmniboxOwnProps> = connect(mapStateToProps)(Omnibox);
